import type { CaseDetail } from '../portfolio';

const androidRetailCase: CaseDetail = {
  id: 'android-retail',
  project: 'Android Retail Strategy',
  client: 'Android / Dentsu Group',
  year: 'Archive',
  category: 'Retail Strategy / Promotion',
  role: 'Retail Strategy / Promotion / Experience',
  issue: '端末の機能価値が強い一方、店頭で他社製品と差別化されにくい状況だった。iPhoneとスマートフォンという売場構成で「android」という露出はほぼなく、主に「メーカー端末」の訴求が中心。スタッフもandroid/Googleサービスについての理解が十分でなく、androidの説明をしても売上に繋がらないという意識があった。',
  challenge: '店頭での体験価値を高め、Androidの世界観を顧客に伝えること。販売代理店、ショップ、そしてスタッフの「意識」から変えていく必要があった。',
  insight: '「make android lover」——端末の性能ではなく、Androidの世界観を愛する体験がシェア拡大の鍵。iPhoneでなくandroidを選んでもらうShop（空間）をつくる。',
  strategy: 'Dentsuグループと連携し、「androidシェア拡大のためのRetail Strategy」として、店頭体験を軸にしたAndroid世界観を体感できるリテール戦略を設計。staff（ヒト）・shop（モノ）・promotion（コト）の3本柱で展開。android Campusによるスタッフ教育プログラム、ショップのモデルパターンに応じた空間設計、Googleによるセールスサポートプログラムで統合的に推進。',
  experience: '店頭体験、デモ、プロモーションを通じて、生活の広がりを体感できる場を構築。android Campusの4つの「場」（Class・Challenge・Test・Present）でスタッフをandroidファンへ。Googleサービスをインタラクティブに体験できるタッチパネルサイネージで、情報の体験とプロダクトの体験でandroidの理解を深める売り場を設計。',
  output: 'Retail Strategy / Experience / Promotion / Store Design / Staff Training Program / Sales Support Program',
  impact: '店頭での差別化と、Android世界観の体感による購買意欲向上を実現。スタッフの意識変革からショップ空間、販売促進まで一気通貫のリテールプログラムを構築。',
  images: [
    {
      src: '/assets/migrated/da265ed89f8a396870e6.webp',
      caption: 'staffインナープログラム＋android Campus概念 — ショップスタッフが得をするインナープログラム開発方針とandroid Campusの4つの「場」から構成される学びの空間',
    },
    {
      src: '/assets/migrated/e571f3a44743340c4f4c.webp',
      caption: 'Design Concept「思わず操作したくなるブランド空間」— 3つのポイント：触るから体験へ・陳列から展示へ・密集からシンプルへ。メーカー名で選ぶ時代から「Androidブランド」というコミュニケーションで選んで頂く',
    },
    {
      src: '/assets/migrated/19204340548c7a1966b5.webp',
      caption: 'ショップの目的イメージ＋現状分析 — Apple/LEXUS/UNIQLOのブランド空間を参考に、staff・shop・promotionの3要素でショップ空間を再設計。現状はiPhone中心でandroidの露出が少なく、スタッフの理解も不十分',
    },
    {
      src: '/assets/migrated/c7adc6f94d017cbf1763.webp',
      caption: 'ショップ現状の課題＋プログラム概要 — キャリア・メーカー施策が乱立しており、スタッフとしても全てを把握しきれていない。販売代理店、ショップ、そしてスタッフの「意識」から変えていく',
    },
    {
      src: '/assets/migrated/b56f97e234e89940fd2e.webp',
      caption: 'android Campus実施＋キャラバン＋エバンジェリスト — 全国を巡回するandroid Campusキャラバン。リアルandroid Campusへの訪問が難しい地方ショップスタッフに対してのサポートを行う',
    },
    {
      src: '/assets/migrated/616f36a4ca46a3feaa9a.webp',
      caption: 'メーカー機能キャラクター＋販売サポートプログラム — メーカーの各機能をキャラクターを使ってわかりやすく紹介。各機能で選ぶリーフレットで「androidを売りやすい環境」をつくるセールスサポートプログラム',
    },
    {
      src: '/assets/migrated/107d8be21514eff87218.webp',
      caption: 'shop B案 店舗CG — Googleサービスをインタラクティブに体験できる、タッチパネルサイネージ。一人で体験から、複数人で体験へ。one to oneからone to themへの情報発信と革新的な世界観の演出',
    },
    {
      src: '/assets/migrated/f1f06c0ae8e0c9f176aa.webp',
      caption: '個店対応サポートスキーム＋全体像 — ショップ（現場）の声を個別に吸い上げ応えていくために事務局をかまえる。Googleとショップで売れる環境を共創していくスキームを構築。staff×shop×promotionでiPhoneでなくandroidを選んでもらう',
    },
    {
      src: '/assets/migrated/c15d04468be787e32f8f.webp',
      caption: 'ショップのモデルパターン＋ご提案の方向性 — L店舗・M店舗・S店舗の立地と種類に応じたモデルパターン分析。A方向：メーカー賛同型のAndroid総合ゾーン展開 / B方向：既存什器を活用したAndroidコーナー展開',
    },
    {
      src: '/assets/migrated/205d754f19e4e36f92bb.webp',
      caption: 'スタッフに期待する「意識」の変化＋android program対象領域 — スタッフの意識を「androidの説明をしても売上に繋がらない」から「android/Googleサービスの説明をすると、お客様に喜ばれる！売上に繋がる！」へ。BtoB領域からBtoBtoC領域まで広げる対象領域設計',
    },
    {
      src: '/assets/migrated/a8af32604c27ab5fe5be.webp',
      caption: '現状のショップのつくり（ゾーニング＋機能）— カウンターゾーン・待合ゾーン・エントランスゾーン・展示ゾーンの4ゾーニングと、機能別（展示・体験・待合・相談・紹介）の空間設計分析',
    },
    {
      src: '/assets/migrated/fac4ce45c61a0163dd5f.webp',
      caption: 'make android lover — 表紙＋Vision&Goal＋目的＋目的イメージ。androidシェア拡大のためのRetail Strategy。目標は3000店舗以上への展開と、キーエモーショナル属性における好感度90%達成',
    },
    {
      src: '/assets/migrated/c549f197dbe8a6d66288.webp',
      caption: 'android Campus 4つの「場」— 入学証（驚きと遊びのある入口）・and Class（自分のスタイルで学べる場）・and Challenge（参加型体験学習の場・店舗対抗クイズ）・and Test（称号獲得の場・認定制度）',
    },
    {
      src: '/assets/migrated/0d45a86bc72cc36db9ce.webp',
      caption: 'androidエバンジェリスト＋トレーニングブック/ブランドブック — android Programを牽引・浸透させるメンバー配置とノウハウの移管。トレーニングブックとブランドブックでスタッフのサービス理解とブランド共感を醸成',
    },
    {
      src: '/assets/migrated/f902cd793760b2bd59a7.webp',
      caption: 'shop 別案 Before/After＋来店目的に応じた体験設計 — 既存什器を流用した導入イメージ。従来のメーカー別陳列からAndroidブランド統合のコーナー展開へ。相談・待合・キッズコーナー・体験・紹介機能を含む総合的な空間設計',
    },
    {
      src: '/assets/migrated/770a10780a07574ec78b.webp',
      caption: 'キャリアショップの考え方＋現状 — 来店目的が異なったお客様をしっかり受け止めるためのコミュニケーション機能が集まる空間。現状はandroidの体験をしていただける空間ではないという課題認識',
    },
    {
      src: '/assets/migrated/f82a4e552f50c833f9d3.webp',
      caption: '「android Branding Plan」表紙 — make android lover。androidシェア拡大のためのRetail Strategyのブランディングプラン表紙',
    },
    {
      src: '/assets/migrated/d284d0f2c61dd7ddb9a2.webp',
      caption: 'shop 別案 既存什器流用の場合①② — 既存の什器にパーツを取り付けることでAndroidブランドコーナーを展開。パターン①：什器ヘッダー+機能キャラクターパネル / パターン②：什器全面にAndroidブランドラッピング',
    },
    {
      src: '/assets/migrated/7612a0d0a3a45471814a.webp',
      caption: 'メーカーの各機能をキャラクターで紹介＋各機能で選ぶリーフレット — and防水・andカメラ・andサイフケータイ・andカスタマイズ・andメモリー・andワンセグなど12機能のキャラクターと、機能別におすすめ端末を紹介するリーフレットデザイン',
    },
    {
      src: '/assets/migrated/9db72711fb0128812979.webp',
      caption: 'Thank you — make android lover shop。おわりに。Androidの世界観を店頭で体感できるリテールプログラムの完結ページ',
    },
  ],
};

export default androidRetailCase;